import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './CertificationLogo.scss';

interface CertificationLogoProps {
  certificationValue: string;
  size?: CertificationLogoSize;
}

export enum CertificationLogoSize {
  SMALL = 'sm',
  MEDIUM = 'md'
}

const CertificationLogo = ({
  certificationValue,
  size = CertificationLogoSize.SMALL
}: CertificationLogoProps) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{certificationValue}</Tooltip>}
    >
      <span
        className={`certification-logo-container certification-logo-container-${size}`}
      >
        <img
          src={
            process.env.REACT_APP_COVALO_STATIC_CONTENT +
            '/certifications/' +
            certificationValue
          }
          className={`certification-logo-image certification-logo-image-${size}`}
          alt={certificationValue + ' certification image'}
        />
      </span>
    </OverlayTrigger>
  );
};

export default CertificationLogo;
